import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";
import api, { apiErrorMessage } from "@/lib/api";

const input = "w-full bg-white border border-neutral-300 rounded-xl px-4 py-3.5 min-h-[44px] text-neutral-900 placeholder:text-neutral-400 focus:outline-none focus:border-neutral-900";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("pd_token", data.token);
      await api.get("/admin/me"); // verify admin rights
      navigate("/admin", { replace: true });
    } catch (e) {
      const status = e?.response?.status;
      if (status === 403) toast.error("This account is not an administrator.");
      else toast.error(apiErrorMessage(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen w-full flex justify-center bg-neutral-100">
      <div className="relative w-full max-w-[430px] min-h-screen bg-white flex flex-col justify-center px-6">
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-2xl bg-neutral-900 text-white mb-4">
          <ShieldCheck size={24} />
        </div>
        <h1 className="font-head text-2xl font-extrabold text-neutral-900">Admin sign in</h1>
        <p className="text-sm text-neutral-500 mt-1 mb-5">Review and verify specialist applications.</p>
        <input data-testid="admin-login-email" className={input} type="email" placeholder="Admin email" value={email} onChange={(e) => setEmail(e.target.value)} />
        <input data-testid="admin-login-password" className={`${input} mt-3`} type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} onKeyDown={(e) => e.key === "Enter" && submit()} />
        <button data-testid="admin-login-submit" onClick={submit} disabled={busy || !email || !password}
          className="mt-5 w-full rounded-full bg-neutral-900 text-white font-bold px-6 py-3.5 min-h-[48px] disabled:opacity-50">
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </div>
    </div>
  );
}
